import * as Scrivito from "scrivito";

const TextPanelWidget = Scrivito.provideWidgetClass("TextPanelWidget", {
  attributes: {
    headline: "string",
    content: "widgetlist",
  },
  extractTextAttributes: ["headline", "content"],
});

export default TextPanelWidget;
